import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import * as analytics from 'lib/analytics'
import { highlightText } from 'lib/highlight-text'
import { setSearchFocused } from 'store/ui/actions'
import { selectMaybeDoi } from 'store/ui/selectors'
import styles from './styles/Dropdown.css'

const SearchLink = ({ term, children, param, category, iconClass = styles.linkIcon }) => {
  const dispatch = useDispatch()

  return (
    <Link
      key='in-all'
      data-showdropdown
      data-dropdown-item
      className={styles.searchLink}
      to={param !== 'question-answering' ? `/search?mode=all&${param}=${term}` : `/search?mode=question-answering&q=${term}`}
      onClick={() => dispatch(setSearchFocused(false))}
    >
      <i className={iconClass} />
      <span className={styles.itemText}>
        {param !== 'question-answering'
          ? (
            <>
              Search <b>{term}</b> {category ? `in ${category}` : ''}
            </>
            )
          : (
            <>
              Ask <b>{term}</b> in ask a question
            </>
            )}
      </span>
    </Link>
  )
}

export const Dropdown = ({
  term,
  onClickResult,
  dropdownStyle,
  field,
  setDropdownOpen,
  showLinks = false
}) => {
  const autocompletes = useSelector(({ ui }) => ui.search.autocompletes)
  const maybeDoi = useSelector(({ ui }) => selectMaybeDoi(ui))
  const completions = autocompletes[field]
  const hasTerm = term && term.length >= 3

  if (!hasTerm || maybeDoi) {
    return null
  }

  return (
    <div className={classNames(styles.dropdown, dropdownStyle)}>
      {showLinks && (
        <>
          <SearchLink key='in-all' term={term} param='q' iconClass={styles.searchIcon} />
          <SearchLink key='in-authors' term={term} param='author' category='authors' />
          <SearchLink key='ask-question' term={term} param='question-answering' iconClass={styles.questionIcon} />
        </>
      )}
      {completions && completions.length > 0 && completions.map((autocomplete, index) => (
        <div
          key={index}
          data-showdropdown
          data-dropdown-item
          tabIndex='0'
          className={styles.dropdownItem}
          onClick={() => {
            analytics.event({
              category: 'Search',
              action: 'Clicked autocomplete result',
              label: autocomplete.completion
            })
            onClickResult(`"${autocomplete.completion}"`)
          }}
        >
          <i className={styles.searchIcon} />
          <span
            className={styles.itemText}
            dangerouslySetInnerHTML={{
              __html: highlightText(
                autocomplete.completion,
                term,
                {
                  startTag: `<span class="${styles.match}">`,
                  endTag: '</span>'
                }
              )
            }}
          />
        </div>
      ))}
    </div>
  )
}

export default Dropdown
